import React, { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router";
import { Link } from "react-router-dom";
import Sidebar from "../../../partials/aside/Sidebar";
import TitleBar from "../../../partials/content/TitleBar";
import helperSpinner from "../../../../helpers/spinner";
import helperNumbers from "../../../../helpers/numbers";
import helperTime from "../../../../helpers/time";
import httpService from "../../../../services/httpServices/httpServices";
import typeOperationLogWallet from "./typeOperationLogWallet";
import Pagination from "../../../partials/content/Pagination";
import { DatePicker } from "react-advance-jalaali-datepicker";

export default function AllLogWalletPublisher() {
  const [allLogWalletPublisher, setAllLogWalletPublisher] = useState([]);

  const [currentPage, setCurrentPage] = useState(1);
  const [countItemPerPage, setCountItemPerPage] = useState(10);
  const [countPage, setCountPage] = useState(1);
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();

  useEffect(() => {
    getAllLogWalletPublisher();
  }, [currentPage]);

  const getAllLogWalletPublisher = async () => {
    const userID = parseInt(document.querySelector("#user-id").value);
    if (!userID) {
      return;
    }
    const searchFilterQuery = getSearchFilterQuery();
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    let allWalletLogPosition = await sendRequestGetAllLogWalletPublisher(
      userID,
      searchFilterQuery
    );
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);

    if (!allLogWalletPublisher) {
      return;
    }

    setAllLogWalletPublisher(allWalletLogPosition.logs_publishers_wallet);
    setCountPage(allWalletLogPosition.count_page);
  };

  const getSearchFilterQuery = () => {
    if (!startDate) {
      return "";
    }
    if (!endDate) {
      return "";
    }
    return `&start_date=${startDate}&end_date=${endDate}`;
  };

  const sendRequestGetAllLogWalletPublisher = async (
    userPublisherID,
    searchFilterQuery
  ) => {
    const headersRequest = getHeaderRequest();
    let allLogWalletPublisher;
    try {
      allLogWalletPublisher = await httpService.getRequest(
        `${process.env.REACT_APP_DOMAIN_API}/v1/manage/publisher/finance/log-wallet/publisher/${userPublisherID}/paginate?page=${currentPage}&number=${countItemPerPage}${searchFilterQuery}`,
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }

    return allLogWalletPublisher.data.data;
  };

  const getHeaderRequest = () => {
    const token = localStorage.getItem("token");
    const headersRequest = {
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    return headersRequest;
  };

  const generateAllLogWalletPublisher = () => {
    return (
      <>
        <div className="alert alert-info mt-2">
          <div>فیلتر در تاریخ درج</div>
          <div className="row pb-2">
            <div className="d-flex align-items-center">
              <div className="custom-data-picker start-date">
                <span> تاریخ شروع</span>
                <DatePicker
                  placeholder="انتخاب تاریخ"
                  format="jYYYY/jMM/jDD"
                  onChange={(unix) => {
                    setStartDate(
                      new Date(unix * 1000).toISOString().split("T")[0]
                    );
                  }}
                />
              </div>
            </div>
            <div className="d-flex align-items-center pr-2">
              <div className="custom-data-picker start-date">
                <span> تاریخ پایان</span>
                <DatePicker
                  placeholder="انتخاب تاریخ"
                  format="jYYYY/jMM/jDD"
                  onChange={(unix) => {
                    setEndDate(
                      new Date(unix * 1000).toISOString().split("T")[0]
                    );
                  }}
                />
              </div>
            </div>
            <div className="d-flex align-items-end pr-2">
              <button
                className="btn btn-success"
                onClick={getAllLogWalletPublisher}
              >
                اعمال فیلتر
              </button>
            </div>
          </div>
        </div>
        <div className="pb-4 px-2">
          <div className="table-responsive pt-2">
            <table className="table table-hilite tbl-td-white-space">
              <thead>
                <tr>
                  <td>#</td>
                  <td>شماره لاگ </td>
                  <td>مبلغ قبل از اعمال</td>
                  <td>مبلغ بعد از اعمال</td>
                  <td>مبلغ اعمال شده</td>
                  <td> نوع تراکنش </td>
                  <td>نوع عملیات </td>
                  <td>شماره ارجاع</td>
                  <td>تاربخ درج</td>
                </tr>
              </thead>
              <tbody>
                {allLogWalletPublisher.map((item, index) => {
                  return (
                    <tr>
                      <td>{helperNumbers.toPersianNum(index + 1)}</td>
                      <td>{helperNumbers.toPersianNum(item.plw_id)}</td>
                      <td className="letter-spacing-finance-number">
                        {helperNumbers.toPersianNum(
                          helperNumbers.toFormatFinanceNumber(
                            item.plw_wallet_before
                          )
                        )}
                      </td>
                      <td className="letter-spacing-finance-number">
                        {helperNumbers.toPersianNum(
                          helperNumbers.toFormatFinanceNumber(
                            item.plw_wallet_after
                          )
                        )}
                      </td>
                      <td className="letter-spacing-finance-number">
                        {helperNumbers.toPersianNum(
                          helperNumbers.toFormatFinanceNumber(item.plw_amount)
                        )}
                      </td>
                      <td>
                        {item.plw_type_payment ? (
                          <span className="badge badge-success">افزایش</span>
                        ) : (
                          <span className="badge badge-warning">کاهش </span>
                        )}
                      </td>
                      <td>
                        {
                          typeOperationLogWallet.getTypeOperationString()[
                            item.plw_type_operation
                          ]
                        }
                      </td>
                      <td>{item.plw_ref_id}</td>
                      <td>
                        {helperNumbers.toPersianNum(
                          item.plw_created_at.split(" ")[1] +
                            " " +
                            helperTime.convertGregorianToJalali(
                              item.plw_created_at.split(" ")[0]
                            )
                        )}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
          {countPage > 1 ? generatePagination() : <></>}
        </div>
      </>
    );
  };

  const paginationItemOnClickHandler = async (e) => {
    if (!e.target.attributes[1]) {
      return;
    }

    setCurrentPage(e.target.attributes[1].value);
  };

  const generatePagination = () => {
    return (
      <div className="py-2 d-flex flex-column flex-md-row  align-items-md-center  ">
        <Pagination
          countPage={countPage}
          currentPage={currentPage}
          paginationItemOnClickHandler={paginationItemOnClickHandler}
        />
      </div>
    );
  };

  const generateUserPublisherDoseNotHaveAnyLogWalletPublisher = () => {
    return (
      <div className="pt-2">
        <div className="alert alert-info">
          این کاربر هیچ گزارش تغییرات موجودی کاربر نمایش دهنده ندارد
        </div>
      </div>
    );
  };

  return (
    <>
      <Sidebar
        openItem="manage-finance"
        activeItem="all-log-wallet-publisher"
      />

      <div className="content-wrapper">
        <TitleBar title="گزارش تغییرات موجودی کاربر نمایش دهنده" />

        <section className="content pt-5">
          <div className="card">
            <div className="card-body">
              <div className="w-50">
                <form
                  onSubmit={(e) => {
                    e.preventDefault();
                    getAllLogWalletPublisher();
                  }}
                >
                  <div class="input-group ">
                    <input
                      type="number"
                      id="user-id"
                      class="form-control"
                      placeholder="شماره کاربر نمایش دهنده را وارد کنید."
                      required
                    />
                    <div class="input-group-append">
                      <button class="btn btn-primary" type="submit">
                        نمایش
                      </button>
                    </div>
                  </div>
                </form>
              </div>
              <div>
                {allLogWalletPublisher.length == 0 && !startDate && !endDate
                  ? generateUserPublisherDoseNotHaveAnyLogWalletPublisher()
                  : generateAllLogWalletPublisher()}
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
